import { render, staticRenderFns } from "./AdminTestfields.vue?vue&type=template&id=603ec9c5&scoped=true"
import script from "./AdminTestfields.vue?vue&type=script&lang=js"
export * from "./AdminTestfields.vue?vue&type=script&lang=js"
import style0 from "./AdminTestfields.vue?vue&type=style&index=0&id=603ec9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ec9c5",
  null
  
)

export default component.exports